import { Duration } from 'dayjs/plugin/duration.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class DurationComponent extends Component {
  static readonly TYPE_ID: string = 'a051b640d4c94f8c8c426f0800571b32';

  constructor(
    public readonly duration: Duration,
  ) {
    super();
  }

  get $typeId() {
    return DurationComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): DurationComponent {
    return new DurationComponent(
        context.decodeDuration(MapUtils.get<number>(map, 'duration')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'duration': context.encodeDuration(this.duration),
    };
  }

  clone(): this {
    return new DurationComponent(
        this.duration,
    ) as this;
  }

  isSame(other: DurationComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.duration === this.duration;
  }
}

export class DurationComponentBuilder extends DataModelBuilder<DurationComponent> {
  build(context: SerializationContext, map: SerializedData): DurationComponent {
    return DurationComponent.fromMap(context, map);
  }
}
